import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getBranchCommission = id => {
    return http.get(
        `${getBaseUrl()}/branch_commission/${id}`
    );
};

export const getBranchCommissions = paginate => {
    if (!paginate) {
        return http.get(
            `${getBaseUrl()}/branch_commission`
        );
    }
    return http.get(
        `${getBaseUrl()}/branch_commission?${paginate}`
    );
};

export const getAgentBranchCommissions = paginate => {
    if (!paginate) {
        return http.get(
            `${getBaseUrl()}/agent_branch_commission`
        );
    }
    return http.get(
        `${getBaseUrl()}/agent_branch_commission?${paginate}`
    );
};

export const getBranchCommissionServiceVat = (agentId, branchId) => {
    return http.get(
        `${getBaseUrl()}/branch_commission_service_vat/${agentId}/${branchId}`
    );
};

export const updateBranchCommission = data => {

    return http.put(
        `${getBaseUrl()}/branch_commission/${data.id}`,
        data
    );
};
export const submitBranchCommission = data => {

    return http.post(
        `${getBaseUrl()}/branch_commission`,
        data
    );
};
